import { useMutation } from '@gogame/query';

import { toggleAutoSyncAudience } from 'scenes/CustomAudiences/Audiences/sources/audiences';

import { toggle } from '../queryKeyFactory';

export const useToggleAutoSyncAudience = () => {
  const toggleAUMutation = useMutation(toggle(), toggleAutoSyncAudience);

  const handleAction = async params => {
    await toggleAUMutation.mutateAsync(params);
  };

  return [handleAction, toggleAUMutation];
};
